// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDashboardContainer {
  padding: 1rem;
}
.mainDashboardContainer .content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border: 2px solid #DCDFE1;
  margin-top: 1rem;
}
.mainDashboardContainer .content .header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ccc;
}
.mainDashboardContainer .content .header .title {
  font-weight: bold;
  font-size: 1rem;
}
.mainDashboardContainer .content .header .iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  background-color: #F4F5F7;
}
.mainDashboardContainer .content .row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
}
.mainDashboardContainer .content .row > :first-child {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.mainDashboardContainer .content .row .circle {
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/dashboard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;AAAZ;AAEY;EACI,iBAAA;EACA,eAAA;AAAhB;AAGY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AADhB;AAMQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAJZ;AAMY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAJhB;AAOY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AALhB","sourcesContent":[".mainDashboardContainer {\n    padding: 1rem;\n\n\n    .content {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        padding: 1rem;\n        border-radius: 1rem;\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n        border: 2px solid #DCDFE1;\n        margin-top: 1rem;\n\n        .header {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            padding-bottom: 0.5rem;\n            border-bottom: 1px solid #ccc;\n\n            .title {\n                font-weight: bold;\n                font-size: 1rem;\n            }\n\n            .iconContainer {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                width: 2rem;\n                height: 2rem;\n                border-radius: 100%;\n                background-color: #F4F5F7;\n            }\n        }\n\n\n        .row {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding:  0.75rem 0;\n\n            > :first-child {\n                display: flex;\n                align-items: center;\n                gap: 0.5rem;\n            }\n\n            .circle {\n                width: 1rem;\n                height: 1rem;\n                border-radius: 100%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
